module.exports = __webpack_public_path__ + "cornerSprite-d9f425962320df2bc1f15faf2218b7d3.png";